/** Local/prod API host from env (dashboard .env REACT_APP_API_URL). */
export function getApiBaseUrl(): string {
  let base = (process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000').trim();
  if (base && !base.match(/^https?:\/\//)) {
    base = `http://${base}`;
  }
  return base.replace(/\/+$/, '').replace(/\/api$/i, '');
}

/** Build public storage URL for a relative path like customers/registrations/... */
export function storageUrl(path?: string | null): string | null {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  const clean = path.replace(/^\/+/, '').replace(/^storage\//, '');
  return `${getApiBaseUrl()}/storage/${clean}`;
}
